// Frontend deploy бүр дээр энэ утгыг солино.
export const FRONTEND_VERSION = "2026.09.11.1";
